module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/NFSWro/tc-custom/9781459231535.jpg?1743822400923",
      "alt": "This image is the cover for the book Viscount's Bride"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Viscount's Bride\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Lady Chloe Had Nowhere To Turn")]), _c('br'), _c('br'), _vm._v("Either she followed her guardian’s dictates and married a wholly detestable suitor or she settled for the comfortable love of a sensible man. Faced with a bleak future on either front, Chloe settled for Mr. Safe and Sensible. It wasn’t until her so-called “safe” choice tried to compromise her reputation that Brandt, Lord Salcombe, rushed in to save her. But how dare Brandt now insist that the next time she wanted a kiss she come to him! Chloe had no illusions about the viscount being ideal husband material. Still, his offer was temptingand certainly promised a future filled with passion!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ann Elizabeth Cree\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0